<div class="container">
    <div class="row justify-content-center">
        <iframe
            src="https://help.roksh.com/szb-tudastar"
            width="100%"
            style="height: 80vh"
        ></iframe>
    </div>
</div>
